const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

const projectMgtRouter = {
  path: '/intermodality',
  component: index,
  children: [
    {
      path: 'projectMain',
      name: 'projectMain',
      component: () => import('@/pages/intermodality/project/projectOverview/index.vue'),
      meta: {
        keepAlive: true,
        title: '项目管理总览',
      },
    },
    {
      path: 'projectCreation',
      name: 'projectCreation',
      component: () => import('@/pages/intermodality/project/projectDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '项目管理新建',
      },
    },
    {
      path: 'projectDetail',
      name: 'projectDetail',
      component: () => import('@/pages/intermodality/project/projectDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '项目管理详情',
      },
    },
    {
      path: 'projectHistoryDetail',
      name: 'projectHistoryDetail',
      component: () => import('@/pages/intermodality/project/projectRecord/index.vue'),
      meta: {
        keepAlive: true,
        title: '项目管理记录',
      },
    },
  ],
};

export default projectMgtRouter;
